import { useContext, useEffect } from 'react';
import { api, rules, FEATURE_FLAG } from '@buzzfeed/consent';
import { isOn } from '@buzzfeed/react-components/lib/utils/abeagle';
import { ABeagleContext } from '../../contexts';

export default function ConsentManagement() {
  const { experiments } = useContext(ABeagleContext);

  // TODO: remove this when adlib is implemented, as fetchCCPAValue() will be called by adlib
  rules.fetchCCPAValue();

  useEffect(() => {
    if (!experiments.loaded || experiments.stale) {
      return;
    }
    const flagState = isOn(experiments, FEATURE_FLAG.name);
    api.configure({ useFallback: !flagState });
  }, [experiments.loaded, experiments.stale]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    api.init({});
  }, []);

  return null;
}
